import locales from './locales';

const getRoleLabel = ({
  invalid,
  isDirector,
  isMajorShareholder,
}: {
  isDirector: boolean | null;
  isMajorShareholder: boolean | null;
  invalid: boolean;
}) => {
  if (invalid) {
    return locales.toComplete;
  } else if (isDirector && isMajorShareholder) {
    return locales.bothRole;
  } else if (isDirector) {
    return locales.directorRole;
  } else if (isMajorShareholder) {
    return locales.majorShareholderRole;
  } else {
    return null;
  }
};

export default getRoleLabel;
